import React from "react";
import { Route, Redirect } from "react-router-dom";

// Private Route Wrapper
export const PrivateRoute = ({ component: Component, loggedIn, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            loggedIn ? <Component {...props} /> : <Redirect to="/" />
        }
    />
);

// Logged-In Route Wrapper
export const LoggedInRoute = ({ component: Component, loggedIn, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            loggedIn ? <Redirect to="/admin/dashboard" /> : <Component {...props} />
        }
    />
);